import list from '../../src/views/project/list'
import createMdPage from '../../src/views/project/create/mdPage'
import createAdviserStep1 from '../../src/views/project/create/adviser/step1'
import createAdviserStep2 from '../../src/views/project/create/adviser/step2'
import createAdviserStep3 from '../../src/views/project/create/adviser/step3'
import createLitigationStep1 from '../../src/views/project/create/litigation/step1'
import createLitigationStep2 from '../../src/views/project/create/litigation/step2'
import createLitigationStep3 from '../../src/views/project/create/litigation/step3'
import createSpecialStep1 from '../../src/views/project/create/special/step1'
import createSpecialStep2 from '../../src/views/project/create/special/step2'
import createSpecialStep3 from '../../src/views/project/create/special/step3'
import contractAdviserCivil from '../../src/views/project/contract/adviser/civil'
import contractAdviserAdministration from '../../src/views/project/contract/adviser/administration'
import contractAdviserCriminal from '../../src/views/project/contract/adviser/criminal'
import contractLitigation from '../../src/views/project/contract/litigation/file'
import contractSpecial from '../../src/views/project/contract/special/file'
import detailsMdPage from '../../src/views/project/details/mdPage'
import detailsTask from '../../src/views/project/details/task'
import detailsSituation from '../../src/views/project/details/situation'
import detailsApproval from '../../src/views/project/details/approval'
import detailsComment from '../../src/views/project/details/comment'
import detailsHistory from '../../src/views/project/details/history'
import detailsReceivables from '../../src/views/project/details/receivables'
import detailsStatistics from '../../src/views/project/details/statistics'
import detialsSeal from '../../src/views/project/details/seal'
import detailsSetting from '../../src/views/project/details/setting'

export default {
  list:list,
  create:{
    mdPage:createMdPage,
    adviser:{
      step1:createAdviserStep1,
      step2:createAdviserStep2,
      step3:createAdviserStep3,
    },
    litigation:{
      step1:createLitigationStep1,
      step2:createLitigationStep2,
      step3:createLitigationStep3,
    },
    special:{
      step1:createSpecialStep1,
      step2:createSpecialStep2,
      step3:createSpecialStep3,
    },
  },
  contract:{
    adviser:{
      civil:contractAdviserCivil,
      administration:contractAdviserAdministration,
      criminal:contractAdviserCriminal,
    },
    litigation:{
      file:contractLitigation,
    },
    special:{
      file:contractSpecial,
    },
  },
  details:{
    mdPage:detailsMdPage,
    task:detailsTask,
    situation:detailsSituation,
    approval:detailsApproval,
    comment:detailsComment,
    history:detailsHistory,
    receivables:detailsReceivables,
    statistics:detailsStatistics,
    seal:detialsSeal,
    setting:detailsSetting,
  },
}